import React from 'react';
import { connect } from 'react-redux';
import { AppBar, Toolbar, Button, Link } from '@mui/material';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { logoutUserActionCreator } from '../../../redux/actions/user';
import getTheme from '../../../theme';

import './AppHeader.css';

const HEADER_PALETTE = {
  primary: {
    main: '#FFFFFF',
  },
  secondary: {
    main: '#FF0000',
  },
};

const AppHeader = ({ isLoggedIn, logout }) => {
  const toolbarStyle = {
    background: `#ff2828`,
  };
  const navigate = useNavigate();
  const theme = getTheme(HEADER_PALETTE);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <AppBar position="fixed" className="header">
          <Toolbar style={toolbarStyle} disableGutters className="toolbar">
            <img className="logo" src="/white-logo.png" alt="Onboard Data" />

            <div className="center" />

            <div className="right">
              <Link
                href="https://onboard.discourse.group/login"
                underline="hover"
                variant="inherit"
              >
                Ask Community
              </Link>
              <span style={{ display: 'inline-block', width: '30px' }} />
              <Link href="https://help.onboarddata.io/" underline="hover" variant="inherit">
                Knowledge Base
              </Link>
              <span style={{ display: 'inline-block', width: '75px' }} />
              {isLoggedIn ? (
                <Button color="primary" onClick={logout}>
                  Log Out
                </Button>
              ) : (
                <Button color="primary" onClick={() => navigate('/login')}>
                  Login
                </Button>
              )}
            </div>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default connect(
  ({ user: { jwt } }) => ({
    isLoggedIn: jwt !== undefined,
  }),
  (dispatch) => ({
    logout: () => dispatch(logoutUserActionCreator()),
  })
)(AppHeader);
